import React, { useState } from "react"
import { useCookies } from "react-cookie"
import AddLessonHandler from "../NewForm/AddLessonHandler"
import PrefsHandler from "./PrefsHandler"
import "./Navbar.css"

function Navbar({ 
    userLoggedIn, 
    userPrefs, 
    setUserPrefs, 
    defaultYear, 
    changeHandler
}) {
    const [ year, setYear ] = useState(defaultYear)

    return (
        <>
            <nav className="navbar">
                { userLoggedIn 
                    ? <AddLessonHandler createHandler={() => changeHandler(year)}/> 
                    : `` 
                }
                <div className="select">
                    <select
                        name="filter-todo"
                        id="filter-todo"
                        className="filter-todo"
                        onChange={e => {
                            setYear(e.target.value)
                            changeHandler(e.target.value)
                        }}
                    >
                        <option value="all">All</option>
                        <option value="1">Anul I</option>
                        <option value="2">Anul II</option>
                        <option value="3">Anul III</option>
                    </select>
                </div>
                <PrefsHandler userPrefs={userPrefs} setUserPrefs={setUserPrefs}/>
            </nav>
        </>
    );
}

export default Navbar;
